import React, { ReactNode } from 'react';

import './filters.css';

type Props = {
  children?: ReactNode;
};

const FiltersTitle = ({ children }: Props) => {
  return <div styleName="filters-title">{children}</div>;
};

export default FiltersTitle;
